var _style, _g, _pattern, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquare1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 97.3 97.3",
    style: {
      enableBackground: "new 0 0 97.3 97.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#858589;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#E2DEDE;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st5{fill:#FA9A63;}\n\t.st6{fill:#FADC63;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:url(#SVGID_1_);stroke:#000000;stroke-miterlimit:10;}\n\t.st9{fill:url(#);stroke:#000000;stroke-miterlimit:10;}\n\t.st10{fill:url(#SVGID_00000010282733919794798860000010531270114531428240_);stroke:#000000;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#FFFFFF;stroke-width:2;stroke-miterlimit:10;}\n\t.st12{fill:#FFFFFF;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("pattern", {
    x: -1258.7,
    y: -724.2,
    width: 250.6,
    height: 266.2,
    patternUnits: "userSpaceOnUse",
    id: "New_Pattern",
    viewBox: "10 -266.2 250.6 266.2",
    style: {
      overflow: "visible"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: -266.2,
    className: "st0",
    width: 250.6,
    height: 266.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M254.6-49.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M254.7-49.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M239.9-41.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M240-41.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.6-24.3c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.6-24.3c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 232.4,
    y1: -42.6,
    x2: 242.6,
    y2: -52.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 230.9,
    y1: -3.3,
    x2: 241.2,
    y2: -13.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.5-49.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M204.5-49.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M189.8-41.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M189.9-41.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M202.5-24.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M202.5-24.3c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M216.7-34.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M216.7-34.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 218.5,
    y1: -40.3,
    x2: 228.8,
    y2: -50.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 215.2,
    y1: -2.6,
    x2: 225.4,
    y2: -12.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 182.2,
    y1: -42.6,
    x2: 192.5,
    y2: -52.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 180.8,
    y1: -3.3,
    x2: 191.1,
    y2: -13.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M154.4-49.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M154.4-49.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.7-41.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M139.7-41.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.3-24.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.4-24.3c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M166.5-34.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M166.6-34.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 168.4,
    y1: -40.3,
    x2: 178.7,
    y2: -50.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 165,
    y1: -2.6,
    x2: 175.3,
    y2: -12.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 132.1,
    y1: -42.6,
    x2: 142.4,
    y2: -52.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 130.7,
    y1: -3.3,
    x2: 141,
    y2: -13.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M104.2-49.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.3-49.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.6-41.8c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.6-41.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.2-24.3c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.3-24.3c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.4-34.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.4-34.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 118.3,
    y1: -40.3,
    x2: 128.6,
    y2: -50.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 114.9,
    y1: -2.6,
    x2: 125.2,
    y2: -12.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 82,
    y1: -42.6,
    x2: 92.3,
    y2: -52.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 80.6,
    y1: -3.3,
    x2: 90.8,
    y2: -13.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.1-49.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.2-49.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M39.4-41.8c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.5-41.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.1-24.3c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.1-24.3c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.3-34.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.3-34.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 68.2,
    y1: -40.3,
    x2: 78.4,
    y2: -50.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 64.8,
    y1: -2.6,
    x2: 75.1,
    y2: -12.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 31.9,
    y1: -42.6,
    x2: 42.1,
    y2: -52.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 30.4,
    y1: -3.3,
    x2: 40.7,
    y2: -13.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4-49.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2-24.3c5.5,0.1,9.9,4.6,9.8,10.1C11.7-8.7,7.2-4.3,1.7-4.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.2-34.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.2-34.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 18,
    y1: -40.3,
    x2: 28.3,
    y2: -50.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 14.7,
    y1: -2.6,
    x2: 24.9,
    y2: -12.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M244.6-102.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.6-102.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M229.9-95c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230-95c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.6-77.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.6-77.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256.8-87.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256.8-87.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 258.6,
    y1: -93.6,
    x2: 268.9,
    y2: -103.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 255.3,
    y1: -55.8,
    x2: 265.5,
    y2: -66.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 222.3,
    y1: -95.8,
    x2: 232.6,
    y2: -106.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 220.9,
    y1: -56.5,
    x2: 231.2,
    y2: -66.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M194.5-102.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.5-102.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M179.8-95c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.8-95c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M192.4-77.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.5-77.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M206.6-87.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.7-87.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 208.5,
    y1: -93.6,
    x2: 218.8,
    y2: -103.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 205.1,
    y1: -55.8,
    x2: 215.4,
    y2: -66.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 172.2,
    y1: -95.8,
    x2: 182.5,
    y2: -106.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.8,
    y1: -56.5,
    x2: 181.1,
    y2: -66.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M144.3-102.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.4-102.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M129.7-95c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.7-95c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M142.3-77.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M142.4-77.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M156.5-87.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5-87.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 158.4,
    y1: -93.6,
    x2: 168.7,
    y2: -103.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155,
    y1: -55.8,
    x2: 165.3,
    y2: -66.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 122.1,
    y1: -95.8,
    x2: 132.4,
    y2: -106.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 120.7,
    y1: -56.5,
    x2: 130.9,
    y2: -66.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M94.2-102.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.3-102.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79.5-95c2.7,0,4.9,4.5,4.8,10S82-75,79.3-75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.6-95c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M92.2-77.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.2-77.5c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M106.4-87.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.4-87.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 108.3,
    y1: -93.6,
    x2: 118.5,
    y2: -103.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 104.9,
    y1: -55.8,
    x2: 115.2,
    y2: -66.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 72,
    y1: -95.8,
    x2: 82.2,
    y2: -106.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 70.5,
    y1: -56.5,
    x2: 80.8,
    y2: -66.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M44.1-102.8c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.1-102.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.4-95c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.4-95c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.1-77.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.1-77.5c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.3-87.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.3-87.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 58.1,
    y1: -93.6,
    x2: 68.4,
    y2: -103.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 54.8,
    y1: -55.8,
    x2: 65,
    y2: -66.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 21.8,
    y1: -95.8,
    x2: 32.1,
    y2: -106.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 20.4,
    y1: -56.5,
    x2: 30.7,
    y2: -66.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.1-87.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.2-87.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 8,
    y1: -93.6,
    x2: 18.3,
    y2: -103.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 4.6,
    y1: -55.8,
    x2: 14.9,
    y2: -66.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M234.6-156c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.6-156c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M219.9-148.2c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M219.9-148.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M232.5-130.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M232.6-130.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M246.7-141c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M246.8-141c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 248.6,
    y1: -146.8,
    x2: 258.9,
    y2: -157.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 245.2,
    y1: -109.1,
    x2: 255.5,
    y2: -119.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 212.3,
    y1: -149.1,
    x2: 222.6,
    y2: -159.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 210.9,
    y1: -109.8,
    x2: 221.2,
    y2: -120.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.4-156c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.5-156c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.8-148.2c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.8-148.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M182.4-130.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.5-130.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.6-141c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M196.6-141c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 198.5,
    y1: -146.8,
    x2: 208.8,
    y2: -157.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.1,
    y1: -109.1,
    x2: 205.4,
    y2: -119.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 162.2,
    y1: -149.1,
    x2: 172.5,
    y2: -159.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 160.8,
    y1: -109.8,
    x2: 171,
    y2: -120.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M134.3-156c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4-156c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.6-148.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.7-148.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.3-130.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M132.3-130.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.5-141c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.5-141c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 148.4,
    y1: -146.8,
    x2: 158.6,
    y2: -157.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 145,
    y1: -109.1,
    x2: 155.3,
    y2: -119.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 112.1,
    y1: -149.1,
    x2: 122.3,
    y2: -159.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 110.6,
    y1: -109.8,
    x2: 120.9,
    y2: -120.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M84.2-156c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.2-156c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.5-148.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.6-148.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.2-130.8c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M82.2-130.7c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.4-141c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.4-141c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 98.2,
    y1: -146.8,
    x2: 108.5,
    y2: -157.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 94.9,
    y1: -109.1,
    x2: 105.1,
    y2: -119.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 61.9,
    y1: -149.1,
    x2: 72.2,
    y2: -159.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 60.5,
    y1: -109.8,
    x2: 70.8,
    y2: -120.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.1-156c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.1-156c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.4-148.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.4-148.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32-130.8c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32.1-130.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M46.2-141c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.3-141c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 48.1,
    y1: -146.8,
    x2: 58.4,
    y2: -157.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 44.7,
    y1: -109.1,
    x2: 55,
    y2: -119.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 11.8,
    y1: -149.1,
    x2: 22.1,
    y2: -159.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10.4,
    y1: -109.8,
    x2: 20.7,
    y2: -120.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M260-201.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260-201.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 252.4,
    y1: -202.3,
    x2: 262.7,
    y2: -212.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 251,
    y1: -163,
    x2: 261.3,
    y2: -173.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.5-209.2c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.6-209.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.9-201.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M209.9-201.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.5-184c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6-184c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M236.7-194.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M236.7-194.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 238.6,
    y1: -200,
    x2: 248.9,
    y2: -210.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 235.2,
    y1: -162.3,
    x2: 245.5,
    y2: -172.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 202.3,
    y1: -202.3,
    x2: 212.6,
    y2: -212.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 200.9,
    y1: -163,
    x2: 211.1,
    y2: -173.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M174.4-209.2c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5-209.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M159.7-201.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.8-201.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M172.4-184c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.4-184c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M186.6-194.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.6-194.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 188.5,
    y1: -200,
    x2: 198.7,
    y2: -210.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 185.1,
    y1: -162.3,
    x2: 195.4,
    y2: -172.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 152.2,
    y1: -202.3,
    x2: 162.4,
    y2: -212.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 150.7,
    y1: -163,
    x2: 161,
    y2: -173.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M124.3-209.2c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.3-209.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M109.6-201.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M109.7-201.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.3-184c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.3-184c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136.5-194.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.5-194.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 138.3,
    y1: -200,
    x2: 148.6,
    y2: -210.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 135,
    y1: -162.3,
    x2: 145.2,
    y2: -172.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 102,
    y1: -202.3,
    x2: 112.3,
    y2: -212.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 100.6,
    y1: -163,
    x2: 110.9,
    y2: -173.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M74.2-209.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.2-209.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M59.5-201.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.5-201.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M72.1-184c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.2-184c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M86.3-194.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.4-194.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 88.2,
    y1: -200,
    x2: 98.5,
    y2: -210.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 84.8,
    y1: -162.3,
    x2: 95.1,
    y2: -172.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 51.9,
    y1: -202.3,
    x2: 62.2,
    y2: -212.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 50.5,
    y1: -163,
    x2: 60.8,
    y2: -173.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24-209.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24.1-209.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.4-201.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.4-201.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22-184c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.1-184c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.2-194.3c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.2-194.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 38.1,
    y1: -200,
    x2: 48.4,
    y2: -210.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 34.7,
    y1: -162.3,
    x2: 45,
    y2: -172.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1.8,
    y1: -202.3,
    x2: 12.1,
    y2: -212.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0.4,
    y1: -163,
    x2: 10.6,
    y2: -173.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M250-254.7c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M250-254.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 242.4,
    y1: -255.6,
    x2: 252.7,
    y2: -265.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 241,
    y1: -216.3,
    x2: 251.2,
    y2: -226.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M214.5-262.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.6-262.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M199.8-254.7c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M199.9-254.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M212.5-237.2c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.5-237.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M226.7-247.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7-247.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 228.6,
    y1: -253.3,
    x2: 238.8,
    y2: -263.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 225.2,
    y1: -215.6,
    x2: 235.5,
    y2: -225.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 192.3,
    y1: -255.6,
    x2: 202.5,
    y2: -265.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 190.8,
    y1: -216.3,
    x2: 201.1,
    y2: -226.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.4-262.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.4-262.4c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M149.7-254.7c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.8-254.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.4-237.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.4-237.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.6-247.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M176.6-247.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 178.4,
    y1: -253.3,
    x2: 188.7,
    y2: -263.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 175.1,
    y1: -215.6,
    x2: 185.3,
    y2: -225.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 142.1,
    y1: -255.6,
    x2: 152.4,
    y2: -265.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 140.7,
    y1: -216.3,
    x2: 151,
    y2: -226.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M114.3-262.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.3-262.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.6-254.7c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.6-254.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.2-237.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.3-237.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M126.4-247.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M126.5-247.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 128.3,
    y1: -253.3,
    x2: 138.6,
    y2: -263.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 124.9,
    y1: -215.6,
    x2: 135.2,
    y2: -225.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 92,
    y1: -255.6,
    x2: 102.3,
    y2: -265.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 90.6,
    y1: -216.3,
    x2: 100.9,
    y2: -226.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.1-262.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.2-262.4c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M49.5-254.7c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.5-254.7c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.1-237.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.2-237.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.3-247.5c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M76.3-247.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 78.2,
    y1: -253.3,
    x2: 88.5,
    y2: -263.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 74.8,
    y1: -215.6,
    x2: 85.1,
    y2: -225.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 41.9,
    y1: -255.6,
    x2: 52.2,
    y2: -265.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 40.5,
    y1: -216.3,
    x2: 50.7,
    y2: -226.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14-262.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.1-262.4c5.5,0.1,9.9,4.6,9.8,10.1s-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12-237.2c2.7,0,4.9,4.5,4.8,10s-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12-237.2c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.2-247.5c2.7,0,4.9,4.5,4.8,10c-0.1,5.5-2.3,9.9-5.1,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M26.2-247.4c5.5,0.1,9.9,4.6,9.8,10.1c-0.1,5.5-4.6,9.9-10.1,9.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 28.1,
    y1: -253.3,
    x2: 38.3,
    y2: -263.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 24.7,
    y1: -215.6,
    x2: 35,
    y2: -225.8
  }))))), _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "SVGID_1_",
    xlinkHref: "#New_Pattern",
    patternTransform: "matrix(1 0 0 1 226.7592 38.4642)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    className: "st8",
    width: 96.3,
    height: 96.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquare1);
export default __webpack_public_path__ + "static/media/Square1.33fcae59ec9fb98f5bc7a10b840e8756.svg";
export { ForwardRef as ReactComponent };